module.exports = __webpack_public_path__ + "static/media/jakarta.e161d4ac.png";